import { connect } from "react-redux";
import { ApplicationState } from "store";
import { actionCreators, getCalendar } from "page/calendar/store";
import { actionCreators as uiActionCreators } from "ui/store";
import CoverTextInput from "./cover-text-input";
import { getResource } from "resource/store";
import { getFontOptions } from "burde-api-content/store";

const mapStateToProps = (state: ApplicationState) => ({
    Cover_Text_Placeholder: getResource(state, {
        key: "Cover_Text_Placeholder",
    }),
    Cover_Text_AddText: getResource(state, { key: "Cover_Text_AddText" }),
    Enable_Text_Rotation: getResource(state, { key: "Enable_Text_Rotation" }),
    calendar: getCalendar(state),
    fontOptions: getFontOptions(state),
});

const mapDispatchToProps = {
    ...actionCreators,
    ...uiActionCreators,
};

export default connect(mapStateToProps, mapDispatchToProps)(CoverTextInput);
